import React from "react"
import Image from "next/image"

import { AffExpertProfile } from "@firmament-packages/aff"

const AffExpertProfileMiniView: React.FunctionComponent<{
    className?: string,
    expertProfile: AffExpertProfile
}> = ({ className, expertProfile }) => {
    return (
        <div className={className}>
            <div className="flex gap-x-[8px]">
                <div className="relative w-[24px] h-[24px] overflow-hidden bg-white-600 rounded-full">
                    <Image layout="fill" objectFit="cover"
                        src={expertProfile.photo?.actualObject?.url || "/images/ic_avatar.svg"}
                        alt={`${expertProfile.name || "Expert"} Profile Photo`} />
                </div>

                <span className="text-footnote text-black-700">{expertProfile.name}</span>
            </div>
        </div>
    )
}

export default AffExpertProfileMiniView
